// Where a timesheet week's hours actually went, as a compact inline list (Session ANF).
//
// SHARED BY THE OFFICE DETAIL PAGE AND THE ENGINEER PWA, deliberately, because the two must never
// print a different answer for the same week: the office invoices from this figure and the engineer
// is paid against it. The buckets, their order, their labels and their minutes are all decided
// SERVER-side (summariseByType in server/src/modules/timesheets/timesheetEntries.ts) and simply
// rendered here, so this component holds no knowledge of the JobType enum and a seventh job type
// would appear through it with no client change at all.
//
// COLOURS ARE THEME TOKENS ONLY, never a hardcoded hex. This renders on two different canvases (the
// office shell and the engineer PWA, which itself has a light theme where [data-theme="light"]
// .engineer-ui repaints the card tokens), and Session AND had to fix exactly this class of bug:
// small text in a hardcoded dark-ground colour failed WCAG AA the moment the light theme applied.
// The CONTAINER is deliberately left to the caller for the same reason: the two shells use
// different card and border tokens, and baking one in would look wrong on the other.
import { formatDurationHm } from "../lib/timeOnSite";
import type { TimesheetBreakdownBucket } from "../lib/api";

export function TimesheetBreakdown({ buckets, className = "" }: { buckets: TimesheetBreakdownBucket[]; className?: string }) {
  if (buckets.length === 0) return null;
  return (
    <ul className={`flex flex-wrap items-baseline gap-x-4 gap-y-1 ${className}`.trim()}>
      {buckets.map((b) => (
        <li key={`${b.kind}:${b.key}`} className="text-sm text-ele-muted">
          <span className="text-ele-strong">{b.label}</span> {formatDurationHm(b.minutes)}
        </li>
      ))}
    </ul>
  );
}
